import { STATUS_LABEL_CLASS } from '../constants';

const getProductStatusClassName = (status) => {
  if (!STATUS_LABEL_CLASS.has(status)) return '';

  return STATUS_LABEL_CLASS.get(status);
};

export default getProductStatusClassName;
